import moment from 'moment';

import { fromAnyDateToTimestamp } from 'utils/converters/time/from.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import IsPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

export const isTimeEqual = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isSame(b);
export const isTimeNotEqual = (a, b) => !isTimeEqual(a, b);

export const isTimeBefore = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isBefore(b);
export const isTimeNotBefore = (a, b) => !isTimeBefore(a, b);
export const isTimeBeforeOrEqual = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isSameOrBefore(b);

export const isTimeAfter = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isAfter(b);
export const isTimeNotAfter = (a, b) => !isTimeAfter(a, b);
export const isTimeAfterOrEqual = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isSameOrAfter(b);

export const isTimeSameDay = (a, b) => isDateWorthy(a) && isDateWorthy(b) && moment(a).isSame(b, 'day');

export const isTimeEqualWithin = (milliseconds, t1, t2) => {
  if (!IsPositiveInteger(milliseconds)) return false;

  const a = fromAnyDateToTimestamp(t1);
  const b = fromAnyDateToTimestamp(t2);

  const difference = Math.abs(a - b);
  if (Number.isNaN(difference)) return false;

  return difference <= milliseconds;
};

export const isTimeBirthday = (birthdayArray, date) => {
  if (!isFullArray(birthdayArray) || !isDateWorthy(date)) return false;

  const [day, month] = birthdayArray;
  const currentMonth = date.getMonth() + 1;
  const currentDay = date.getDate();

  return currentMonth === month && currentDay === day;
};
